import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface GreenButtonProps {
  children: React.ReactNode;
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: 'solid' | 'outline';
  className?: string;
}

const GreenButton: React.FC<GreenButtonProps> = ({ children, to, href, onClick, variant = 'solid', className = '' }) => {
  const base =
    'group inline-flex items-center gap-2 font-poppins font-semibold text-[11px] tracking-[0.12em] uppercase px-6 py-3 transition-colors duration-300';
  const look =
    variant === 'solid'
      ? 'bg-[#78BE20] text-white hover:bg-[#64A70B]'
      : 'border border-current text-current hover:bg-[#78BE20] hover:border-[#78BE20] hover:text-white';
  const cls = `${base} ${look} ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (to) return <Link to={to} className={cls}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>{inner}</a>;
  return <button type="button" onClick={onClick} className={cls}>{inner}</button>;
};

export default GreenButton;
